module.exports = __webpack_public_path__ + "static/CardOfDarkness6-6cef0d51207a81cf27d66ecb55acc500.webp";